// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1ucGv","title":"BackImages_title__Sb3jJ","images":"BackImages_images__2XT8-"};